import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import "./AutomationMatchingTicketsHeader.scss";

const AutomationMatchingTicketsHeader = ({ automationId, automationName }) => {
    return (
        <div className='automation-matching-tickets__heading'>
            <div className='pre__nav padded__layout'>
                <Link to='/t-sam/automations'>Automations</Link>
                <ReactSVG
                    src={asset?.icons?.rightBlack}
                    className='anchor-right'
                />
                <Link to={`/t-sam/automation/${automationId}`}>
                    {automationName || "Edit automation"}
                </Link>
                <ReactSVG
                    src={asset?.icons?.rightBlack}
                    className='anchor-right'
                />
                <p>Matching tickets</p>
            </div>
        </div>
    );
};

export default AutomationMatchingTicketsHeader;
